import pushClevertapEvent from 'clevertap/pushClevertapEvent';
import { deviceType, browserName } from 'react-device-detect';

/**
 * Get device used by user
 * @return {string}
 */
function getUserDevice() {
  switch (deviceType) {
    case 'mobile':
      return 'Mobile';
    case 'tablet':
      return 'Tablet';
    case 'browser':
      return 'Desktop';
  }
}

export function welcome(user) {
  pushClevertapEvent('FTUE Welcome', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourStart(user) {
  pushClevertapEvent('FTUE Mulai Tur Sekarang', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourDashboard(user) {
  pushClevertapEvent('FTUE BO Tour Dashboard', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourDashboardNext(user) {
  pushClevertapEvent('FTUE BO Tour Dashboard - Lanjut', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourReports(user) {
  pushClevertapEvent('FTUE BO Tour Reports', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourReportsNext(user) {
  pushClevertapEvent('FTUE BO Tour Reports - Lanjut', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourReportsBack(user) {
  pushClevertapEvent('FTUE BO Tour Reports - Kembali', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourLibrary(user) {
  pushClevertapEvent('FTUE BO Tour Library', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourLibraryNext(user) {
  pushClevertapEvent('FTUE BO Tour Library - Lanjut', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourLibraryBack(user) {
  pushClevertapEvent('FTUE BO Tour Library - Kembali', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourInventory(user) {
  pushClevertapEvent('FTUE BO Tour Inventory', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourInventoryNext(user) {
  pushClevertapEvent('FTUE BO Tour Inventory - Lanjut', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourInventoryBack(user) {
  pushClevertapEvent('FTUE BO Tour Inventory - Kembali', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourCustomers(user) {
  pushClevertapEvent('FTUE BO Tour Customers', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourCustomersNext(user) {
  pushClevertapEvent('FTUE BO Tour Customers - Lanjut', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourCustomersBack(user) {
  pushClevertapEvent('FTUE BO Tour Customers - Kembali', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourModularFeatures(user) {
  pushClevertapEvent('FTUE BO Tour Modular Features', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourModularFeaturesNext(user) {
  pushClevertapEvent('FTUE BO Tour Modular Features - Lanjut', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourModularFeaturesBack(user) {
  pushClevertapEvent('FTUE BO Tour Modular Features - Kembali', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourEmployees(user) {
  pushClevertapEvent('FTUE BO Tour Employees', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourEmployeesNext(user) {
  pushClevertapEvent('FTUE BO Tour Employees - Lanjut', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourEmployeesBack(user) {
  pushClevertapEvent('FTUE BO Tour Employees - Kembali', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourEcosystemProducts(user) {
  pushClevertapEvent('FTUE BO Tour Ecosystem Products', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourEcosystemProductsNext(user) {
  pushClevertapEvent('FTUE BO Tour Ecosystem Products - Lanjut', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourEcosystemProductsBack(user) {
  pushClevertapEvent('FTUE BO Tour Ecosystem Products - Kembali', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourAccountSettings(user) {
  pushClevertapEvent('FTUE BO Tour Account Settings', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourAccountSettingsNext(user) {
  pushClevertapEvent('FTUE BO Tour Account Settings - Lanjut', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourAccountSettingsBack(user) {
  pushClevertapEvent('FTUE BO Tour Account Settings - Kembali', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourKnowledgeCenter(user) {
  pushClevertapEvent('FTUE BO Tour Knowledge Center', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourKnowledgeCenterNext(user) {
  pushClevertapEvent('FTUE BO Tour Knowledge Center - Lanjut', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourKnowledgeCenterBack(user) {
  pushClevertapEvent('FTUE BO Tour Knowledge Center - Kembali', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourEnd(user) {
  pushClevertapEvent('FTUE BO Tour End', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourComplete(user) {
  pushClevertapEvent('FTUE BO Tour Complete', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}

export function tourRestart(user) {
  pushClevertapEvent('FTUE BO Tour Restart', {
    Email: user.email,
    'Phone Number': user.phone,
    Device: getUserDevice(),
    Browser: browserName,
  });
}
